import { render, staticRenderFns } from "./SideBlock.vue?vue&type=template&id=445ceba4&scoped=true"
import script from "./SideBlock.vue?vue&type=script&lang=js"
export * from "./SideBlock.vue?vue&type=script&lang=js"
import style0 from "./SideBlock.vue?vue&type=style&index=0&id=445ceba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ceba4",
  null
  
)

export default component.exports